// FUNCTIONS
const renderCulturesInitial = () => {
	document.querySelectorAll('.cultures-lo input[class^="photo-"]').forEach((element) => {
		if (!element.classList.contains('photo-1')) {
			imageArray.push(element.value);
		}
	});

	preloadImages(imageArray);
};

const updateCultureBlockCopy = () => {
	const expertise = document.querySelector('.expertise-' + currentNumber).value;
	const image = document.querySelector('.photo-' + currentNumber).value;
	const name = document.querySelector('.name-' + currentNumber).value;
	const quote = document.querySelector('.quote-extended-' + currentNumber).value;

	document.querySelector('.cultures-lo .copy-box .extended-quote').htmlContent = quote;
	document.querySelector('.cultures-lo .copy-box .name').textContent = name;
	document.querySelector('.cultures-lo .copy-box .position .expertise').textContent = expertise;
	document.querySelector('.cultures-lo .copy-box img').src = image;

	document.querySelector('.current-number').textContent = leftPad(currentNumber, 2);
};

// VARIABLES
const maxNumber = parseInt(document.querySelector('.max-number').textContent);
const venues = document.querySelector('.featured-venues .venues');

let currentNumber = parseInt(document.querySelector('.current-number').textContent);
let imageArray = new Array;
let rgbaSelected;

// INITIALIZATION
renderCulturesInitial();

// EVENT LISTENERS
document.querySelector('.controls .next').addEventListener('click', () => {
	if (currentNumber == maxNumber) {
		currentNumber = 1;
	} else {
		currentNumber++;
	}

	updateCultureBlockCopy();
});

document.querySelector('.controls .prev').addEventListener('click', () => {
	if (currentNumber == 1) {
		currentNumber = maxNumber;
	} else {
		currentNumber--;
	}

	updateCultureBlockCopy();
});

document.querySelector('.featured-venues .venue.desktop.expanded')?.addEventListener('transitionend', (event) => {
	const element = event.currentTarget;

	element.querySelector('.overlay').style.background = 'linear-gradient(to bottom, rgba(' + rgbaSelected + ', 0) 50%, rgba(' + rgbaSelected + ', 1) 100%);';

	element.classList.add('expanded');
});

document.querySelector('.featured-venues .venue.mobile.expanded')?.addEventListener('transitionend', (event) => {
	event.currentTarget.classList.add('expanded');
});

venues.addEventListener('click', (event) => {
	if (event.target.closest('.venue.desktop')) {
		const expanded = document.querySelector('.featured-venues .venue.desktop.expanded');
		const selected = event.target.closest('.venue.desktop');

		const rgba = document.querySelector('input[name="venue-' + selected.parentElement.id + '-desktop-rgba"]').value;

		if (expanded && !selected.classList.contains('expanded')) {
			const expandedID = expanded.parentElement.id;
			const selectedID = selected.parentElement.id;

			const rgbaExpanded = document.querySelector('input[name="venue-' + expandedID + '-desktop-rgba"]').value;
			rgbaSelected = document.querySelector('input[name="venue-' + selectedID + '-desktop-rgba"]').value;

			expanded.querySelector('.overlay').style.backgroud = 'rgba(' + rgbaExpanded + ', .5)';
			expanded.classList.remove('expanded');
		}

		selected.querySelector('.overlay').style.backgroud = 'linear-gradient(to bottom, rgba(' + rgba + ', 0) 50%, rgba(' + rgba + ', 1) 100%)';

		selected.classList.add('expanded');
	} else if (event.target.closest('.venue.mobile')) {
		const expanded = document.querySelector('.featured-venues .venue.mobile.expanded');
		const selected = event.target.closest('.venue.mobile');

		console.log(expanded, selected);

		if (expanded && !selected.classList.contains('expanded')) {
			const expandedID = expanded.parentElement.id;
			rgbaExpanded = document.querySelector('input[name="venue-' + expandedID + '-mobile-rgba"]').value;

			expanded.querySelector('.overlay').style.background = 'rgba(' + rgbaExpanded + ', .5)';
			expanded.classList.remove('expanded');
		}

		selected.classList.add('expanded');
	}
});